import { Stack } from '@mui/material';
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import { useAuth0Context } from 'src/auth/auth0';
import { OnboardingLoginWrapper } from 'src/layouts/OnboardingLoginWrapper';

export const Route = createFileRoute('/(auth)')({
    beforeLoad: ({ context }) => {
        const { isAuthenticated } = context.auth ?? {};

        if (isAuthenticated) {
            // If user is authenticated, redirect to home
            throw redirect({ to: '/home', replace: true });
        }
    },
    component: UnauthenticatedRoute,
});

function UnauthenticatedRoute() {
    const { isLoading } = useAuth0Context();

    return (
        <OnboardingLoginWrapper>
            {isLoading ? (
                <Stack
                    sx={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '100dvh',
                        gap: 2,
                    }}
                >
                    <LoadingSpinner message="Checking authentication..." />
                </Stack>
            ) : (
                <Outlet />
            )}
        </OnboardingLoginWrapper>
    );
}
